import React, { useState, useRef, useEffect } from "react";
import { GoogleMap, DirectionsRenderer, useJsApiLoader } from "@react-google-maps/api";
import { GOOGLE_APIKEY } from "../consts";
import logger from "../services/Logger";
import { distanceBetweenTwoPoints, getAddressFromString } from "../services/directions";

const MapWithRoute = (props) => {
  const [directions, setDirections] = useState(null);
  // const [waypoints, setWaypoints] = useState([]);
  const [locations, setLocations] = useState(props.locations);
  // const [destination, setDestination] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    setLocations(props.locations); // Update state when props.newData changes
  }, [props.locations]);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: GOOGLE_APIKEY,
  });

  const mapRef = useRef(null);

  const origin = props.origin;

  const handleLoad = (map) => {
    mapRef.current = map;
  };

  const findStartAndEndPoints = async () => {
    try {
      let longestDistance = {
        distance: 0,
        startPoint: null,
        endPoint: null,
      };
      for (let i = 0; i < locations.length; i++) {
        for (let j = i + 1; j < locations.length; j++) {
          const distance = await distanceBetweenTwoPoints(locations[i], locations[j]);
          if (distance > longestDistance.distance) {
            longestDistance.distance = distance;
            longestDistance.startPoint = locations[i];
            longestDistance.endPoint = locations[j];
          }
        }
      }

      const originAddressInfo = await getAddressFromString(origin);

      const distanceFromStartPoint = await distanceBetweenTwoPoints(originAddressInfo, longestDistance.startPoint);
      const distanceFromEndPoint = await distanceBetweenTwoPoints(originAddressInfo, longestDistance.endPoint);

      return distanceFromStartPoint > distanceFromEndPoint ? longestDistance.startPoint : longestDistance.endPoint;
    } catch (error) {
      logger.error("Error finding start and end points:", error);
      setError("Failed to calculate route points");
      return null;
    }
  };

  const getDirections = async () => {
    try {
      setError(null);
      const destination = await findStartAndEndPoints();
      if (!destination) {
        throw new Error("Failed to find destination");
      }
      // setDestination(destination);
      const calculatedWaypoints = [];
      logger.info("This is the locations we are adding as waypoints and the destination - ", locations, destination);
      locations.forEach((location) => {
        if (location.locationAddress !== destination.locationAddress) {
          const waypoint = {
            location: location.locationAddress,
            stopover: true,
          };
          calculatedWaypoints.push(waypoint);
        }
      });
      // setWaypoints(calculatedWaypoints);
      console.log("These are the waypoints we are sending - ", calculatedWaypoints);
      const directionsService = new window.google.maps.DirectionsService();
      directionsService.route(
        {
          origin: origin,
          destination: destination.locationAddress,
          waypoints: calculatedWaypoints,
          travelMode: window.google.maps.TravelMode.DRIVING,
          optimizeWaypoints: true,
        },
        (response, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            console.log("this is our mapRef - ", mapRef);
            if (mapRef.current) {
              mapRef.current = null;
            }
            setDirections(response);
            props.onRouteCalculated(response.routes);
          } else {
            console.error("Error fetching directions:", status);
            setError("Failed to calculate route");
          }
        }
      );
    } catch (error) {
      console.error("Error in getDirections:", error);
      setError("Failed to calculate route");
    }
  };

  const clearRoute = () => {
    setDirections(null);
    // setDestination(null);
    setError(null);
  };

  return isLoaded ? (
    <div>
      <GoogleMap mapContainerStyle={{ height: "400px", width: "100%" }} zoom={4} onLoad={handleLoad}>
        {directions && <DirectionsRenderer directions={directions} />}
      </GoogleMap>
      {error && <div style={{ color: "red", margin: "10px 0" }}>{error}</div>}
      <button disabled={origin ? false : true} onClick={getDirections}>
        Get Directions
      </button>
      <button onClick={clearRoute}>Clear Route</button>
    </div>
  ) : (
    <></>
  );
};

export default MapWithRoute;
